const KENTE = ["#8C1C13", "#D4AF37", "#1E3F20", "#0A0908"];

function stripe(ctx, x, y, w, h) {
  const seg = w / KENTE.length;
  KENTE.forEach((c, i) => {
    ctx.fillStyle = c;
    ctx.fillRect(x + i * seg, y, seg, h);
  });
}

export async function certificateToBlob(cert, studentName) {
  const W = 1200, H = 900;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#fdfbf6";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "#D4AF37";
  ctx.lineWidth = 8;
  ctx.strokeRect(24, 24, W - 48, H - 48);
  ctx.lineWidth = 2;
  ctx.strokeRect(44, 44, W - 88, H - 88);
  ctx.strokeStyle = "#0A0908";
  ctx.lineWidth = 1;
  ctx.strokeRect(58, 58, W - 116, H - 116);

  stripe(ctx, 90, 92, W - 180, 10);
  stripe(ctx, 90, H - 102, W - 180, 10);

  ctx.textAlign = "center";
  ctx.fillStyle = "#8C1C13";
  ctx.font = "600 24px Georgia, serif";
  ctx.fillText("O U R   A F R I C A N   N A R R A T I V E S", W / 2, 170);

  ctx.fillStyle = "#0A0908";
  ctx.font = "600 64px Georgia, serif";
  ctx.fillText("Certificate of Achievement", W / 2, 260);

  ctx.fillStyle = "#666";
  ctx.font = "italic 26px Georgia, serif";
  ctx.fillText("proudly presented to", W / 2, 330);

  ctx.fillStyle = "#8C1C13";
  ctx.font = "600 56px Georgia, serif";
  ctx.fillText(studentName || "Student", W / 2, 410);

  ctx.fillStyle = "#333";
  ctx.font = "26px Georgia, serif";
  ctx.fillText("for outstanding work on", W / 2, 475);

  ctx.fillStyle = "#0A0908";
  ctx.font = "600 38px Georgia, serif";
  ctx.fillText(cert.title, W / 2, 535);

  const badge = `Achieved ${cert.score}%`;
  ctx.font = "700 32px Georgia, serif";
  const bw = ctx.measureText(badge).width + 60;
  ctx.strokeStyle = "#D4AF37";
  ctx.lineWidth = 3;
  ctx.strokeRect(W / 2 - bw / 2, 575, bw, 64);
  ctx.fillStyle = "#0A0908";
  ctx.fillText(badge, W / 2, 620);

  ctx.font = "22px Georgia, serif";
  ctx.fillStyle = "#555";
  ctx.textAlign = "left";
  const dateStr = cert.awarded_at ? new Date(cert.awarded_at).toLocaleDateString() : new Date().toLocaleDateString();
  ctx.fillText(`Date: ${dateStr}`, 120, 730);
  ctx.textAlign = "right";
  ctx.fillText(`Educator: ${cert.awarded_by || ""}`, W - 120, 730);

  return new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
}
